import { render, staticRenderFns } from "./submissions-tab.vue?vue&type=template&id=3c16f944"
import script from "./submissions-tab.vue?vue&type=script&lang=js"
export * from "./submissions-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports